import React, { useState, useEffect } from 'react';
import { PageHeader, Btn } from '../../components/UI';
import { adminApi } from '../../utils/api';

const ICONS = { new_registration: '👤', new_payment: '💰', password_reset: '🔑', website_lead: '📋', new_ticket: '🎫', auto_suspended: '🚫' };

export default function AdminNotifications() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi.get('/api/admin/notifications').then(r => { if (r.data.success) setNotifications(r.data.notifications); }).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <PageHeader title="Admin Notifications" />
      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: 40, color: 'var(--text-muted)' }}>Loading...</div>
        ) : notifications.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 60, color: 'var(--text-muted)' }}><div style={{ fontSize: 48, marginBottom: 16 }}>🔔</div><div>No admin notifications</div></div>
        ) : notifications.map(n => (
          <div key={n.id} style={{ display: 'flex', alignItems: 'flex-start', gap: 14, padding: '16px 20px', borderBottom: '1px solid var(--border)', background: n.is_read ? 'transparent' : 'rgba(255,215,0,0.02)' }}>
            <div style={{ fontSize: 20, marginTop: 2 }}>{ICONS[n.type] || '🔔'}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: n.is_read ? 400 : 600, fontSize: 14, marginBottom: 4 }}>{n.title}</div>
              <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>{n.message}</div>
              <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 6 }}>{new Date(n.created_at).toLocaleString('en-IN')}</div>
            </div>
            {!n.is_read && <div style={{ width: 8, height: 8, background: '#ffd700', borderRadius: '50%', marginTop: 6, flexShrink: 0 }} />}
          </div>
        ))}
      </div>
    </div>
  );
}